import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';
import { IWalletViewModel } from 'viewModels';
import { ReactComponent as WalletIcon } from '../../../assets/icons/IconWallet.svg';
import { CardAccounts } from '../../Cards/CardAccounts';
import { Container } from './styles';

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
  correspondentWallet?: IWalletViewModel;
}
export function ModalSeeWallet({ correspondentWallet, isOpen, onRequestClose }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-see-wallet-modal-content">
      <Container>
        <div className="header">
          <h1>
            <WalletIcon /> Carteira
          </h1>
          <div className="close">
            <button type="button" onClick={onRequestClose}>
              <CloseIcon fontSize="small" />
            </button>
          </div>
        </div>
        {correspondentWallet &&
        (correspondentWallet?.bankAccounts?.length !== 0 ||
          correspondentWallet?.pixAccounts?.length !== 0) ? (
          <div className="containerAccounts">
            {correspondentWallet?.bankAccounts?.map((bankAccount) => (
              <CardAccounts type="bank" bankAccountSelected={bankAccount} key={bankAccount.id} />
            ))}
            {correspondentWallet?.pixAccounts?.map((pixAccount) => (
              <CardAccounts type="pix" pixAccountSelected={pixAccount} key={pixAccount.id} />
            ))}
          </div>
        ) : (
          <p>Não há registros cadastrados.</p>
        )}
      </Container>
    </Modal>
  );
}
